import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Spinner from '@/Components/Spinner/Spinner';
import { formatSizeToReadableString } from '@standardnotes/filepicker';
import { SettingName } from '@standardnotes/snjs';
import { useEffect, useState } from 'react';
import { c, msgid } from 'ttag';
import { Subtitle, Title } from '../../PreferencesComponents/Content';
import PreferencesGroup from '../../PreferencesComponents/PreferencesGroup';
import PreferencesSegment from '../../PreferencesComponents/PreferencesSegment';
const FilesSection = ({ application }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [filesQuotaUsed, setFilesQuotaUsed] = useState(0);
    const [filesQuotaTotal, setFilesQuotaTotal] = useState(0);
    useEffect(() => {
        const getFilesQuota = async () => {
            const filesQuotaUsed = await application.settings.getSubscriptionSetting(SettingName.create(SettingName.NAMES.FileUploadBytesUsed).getValue());
            if (filesQuotaUsed) {
                setFilesQuotaUsed(parseFloat(filesQuotaUsed));
            }
            if (application.sessions.isSignedIntoFirstPartyServer()) {
                const filesQuotaTotal = await application.settings.getSubscriptionSetting(SettingName.create(SettingName.NAMES.FileUploadBytesLimit).getValue());
                if (filesQuotaTotal) {
                    setFilesQuotaTotal(parseFloat(filesQuotaTotal));
                }
            }
            setIsLoading(false);
        };
        getFilesQuota().catch(console.error);
    }, [application]);
    const filesQuotaUsedLabel = formatSizeToReadableString(filesQuotaUsed);
    const filesQuotaTotalLabel = application.sessions.isSignedIntoFirstPartyServer()
        ? formatSizeToReadableString(filesQuotaTotal)
        : '∞';
    /** The plural form must follow the number shown to the user (e.g. "1 MB"), not the raw byte count */
    const filesQuotaUsedDisplayedAmount = parseFloat(filesQuotaUsedLabel);
    const filesQuotaText = c('B6.Preferences.Account.Info').ngettext(msgid `${filesQuotaUsedLabel} of ${filesQuotaTotalLabel} used`, `${filesQuotaUsedLabel} of ${filesQuotaTotalLabel} used`, filesQuotaUsedDisplayedAmount);
    return (_jsx(PreferencesGroup, { children: _jsxs(PreferencesSegment, { children: [_jsx(Title, { children: c('B6.Preferences.Account.Info').t `Files` }), _jsx(Subtitle, { children: c('B6.Preferences.Account.Info').t `Storage Quota` }), isLoading ? (_jsx("div", { className: "mt-2", children: _jsx(Spinner, { className: "h-3 w-3" }) })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "mb-1 mt-1", children: filesQuotaText }), _jsx("progress", { className: "progress-bar w-full", "aria-label": c('B6.Preferences.Account.Label').t `Files storage used`, value: filesQuotaUsed, max: filesQuotaTotal })] }))] }) }));
};
export default FilesSection;
